import { isLegalSegment } from "@pontimed/ui-legal";
import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy / external entry-point translator: any link of the form
 * `/legal/<segment>` (share-link from web, push notification deep link,
 * Capacitor cold start) redirects to the dashboard with the LegalSheet
 * pre-opened via `?legal=<segment>`. The portal no longer renders a
 * standalone /legal page — `<LegalSheetProvider>` at the app root reads
 * `?legal` and overlays the sheet on top of whatever route is mounted.
 *
 * Top-level (not under `_anon`) because there is nothing to layout — the
 * `beforeLoad` throws before any component mounts.
 */
export const Route = createFileRoute("/legal/$segment")({
  beforeLoad: ({ params }) => {
    const segment = isLegalSegment(params.segment) ? params.segment : "terms";
    throw redirect({ to: "/", search: { legal: segment } });
  },
});
